import React from 'react';
import {Plan} from '../../database/schemas/plan';
import moment from 'moment';
import ImageIcon from '../general/ImageIcon';
import {Card, Title} from '../../styled-components/Card';
import {Row} from '../../styled-components/Row';
import {Field, Label} from '../../styled-components/Field';
import {Light} from '../../styled-components/Text';
import {plansDir} from '../../hooks/usePlans';
import styled from 'styled-components/native';
import {Text} from 'react-native';
import {contentUrl} from '../../api';
import {useContentSignature} from '../ContentSignature';

const PlanInfo = styled(Field)`
  max-width: 85%;
`;

const Preview = styled(Text)`
  color: rgb(254, 0, 0);
  font-weight: bold;
`;

interface PlanListItemProps {
  plan: Plan;
}

const PlanListItem = ({plan}: PlanListItemProps) => {
  const version = (plan.version || 0).toString().match(/^-?\d+(?:\.\d{0,3})?/);
  // The numeric version model cannot distinguish values such as 1.1 and
  // 1.10. Package and media IDs remain lossless across publishes, so use
  // them to invalidate the icon URL and ImageIcon retry lifecycle.
  const iconRevision = `${plan.planContentPackageID}:${
    plan.iconMediaID || ''
  }`;
  const {contentSignature} = useContentSignature();
  return (
    <Card>
      <Row>
        <PlanInfo>
          <Label>
            {plan.planStatus === 'Draft' && (
              <>
                <Preview>Preview</Preview>
                {'  •  '}
              </>
            )}
            {moment(plan.publishedDate).format('MMM D, YYYY')}
            {'  •  '}V.
            {version && version.length ? version[0] : 0}
          </Label>
          <Title>{plan.name}</Title>
          {plan.description && <Light>{plan.description}</Light>}
        </PlanInfo>
        <ImageIcon
          revision={iconRevision}
          source={{
            uri: `${contentUrl}/${plan.planID}/icon.png${contentSignature}`,
          }}
        />
      </Row>
    </Card>
  );
};

export default PlanListItem;
